



































import { dateTimeFormatters } from '@/lib/formatters/dateTime'
import { defineComponent, onBeforeMount, reactive, watch } from '@vue/composition-api';
import { NotificationStoreKey } from "@/store/StoreInjectionKeys";
import { injectStrict } from "@/lib/utils";
import AgTable from '@/modules/ees/components/AgTable.vue';
import ViewNotificationBodyColumnRendererVue from './components/ViewNotificationBodyColumnRenderer.vue';
import { filter } from 'vue/types/umd';
import Datepicker from 'vuejs-datepicker';

export interface NotificationFilter {
  dateFrom: Date | null, 
  dateTo: Date | null,
}

export default defineComponent({
  components: {
    Datepicker,
    AgTable
  },
  setup(props) {
    const notificationStore = injectStrict(NotificationStoreKey);

    // Default to one week ago
    let filter : NotificationFilter = reactive({
      dateFrom: new Date(new Date().setDate(-7)), 
      dateTo: null,
    })

    const table = { 
      columnDefs: [
        {
          field: 'subject',
          headerName: 'Subject',
          flex: 1,
        },
        {
          field: 'recipients',
          headerName: 'Recipients',
          flex: 1,
        },
        {
          field: 'createdAt',
          headerName: 'Created',
          flex: 1,
          type: ['dateColumn'],
        },
        {
          field: 'sentAt',
          headerName: 'Sent',
          flex: 1,
          type: ['dateColumn'],
        },
        {
          field: 'body',
          headerName: '',
          type: ['nonSortable', 'nonFilterable',],
          cellClass: 'actions-button-cell',
          width: 100,
          cellRendererFramework: ViewNotificationBodyColumnRendererVue,
        },
      ]
    }

    watch(() => filter.dateFrom, () => {
      notificationStore.actions.listNotifications(filter.dateFrom, filter.dateTo)
    })
    watch(() => filter.dateTo, async () => {
      await notificationStore.actions.listNotifications(filter.dateFrom, filter.dateTo)
    })

    onBeforeMount(async () => {
      await notificationStore.actions.listNotifications(filter.dateFrom, filter.dateTo)
    })

    const state = reactive({
      notificationStore,
      table,
      filter,
    })
    return state
  }
})
